<template>
    <div class="automation-wizard-field-priority">
        <CompassFormItem v-bind="formItemProps">
            <CompassIconButton :icon="icon" :class="iconClass" @click="updatePriority" />
        </CompassFormItem>
    </div>
</template>

<script>
export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            localValue: this.modelValue,
        };
    },
    computed: {
        formItemProps() {
            return {
                label: this.field.props?.formItem?.label || '',
            };
        },
        icon() {
            return this.localValue ? 'flash-fill' : 'flash';
        },
        iconClass() {
            return {
                'automation-wizard-field-priority__icon': true,
                'is-active': this.localValue,
            };
        },
    },
    methods: {
        updatePriority() {
            this.localValue = !this.localValue;
            this.$emit('update:modelValue', this.localValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-wizard-field-priority {
    &__icon {
        width: var(--spacing-5);
        height: var(--spacing-5);
    }

    :deep() {
        .is-active.compass-icon-button > .compass-icon-button__content {
            color: var(--colors-common-background-warning-default);
        }
    }
}
</style>
